var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAuthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 451.601,
    height: 498.091,
    viewBox: "0 0 451.601 498.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4122",
    "data-name": "Trazado 4122",
    d: "M63.3,252.772c0,124.706,101.093,225.8,225.8,225.8s225.8-101.095,225.8-225.8S413.81,26.972,289.1,26.972,63.3,128.067,63.3,252.772",
    transform: "translate(-63.304 -26.972)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4151",
    "data-name": "Trazado 4151",
    d: "M162.066,169.15a34.05,34.05,0,0,0-21.253,16.63L82.433,292.8a26.2,26.2,0,0,0,23,38.741h231.9l34.06-54.632-60.292-95.574a33.221,33.221,0,0,0-18.283-14.012l-28.241-8.734-9.539-.066v.619a20.881,20.881,0,0,1-41.761,0v-.9l-9.385-.064Z",
    transform: "translate(-79.232 -158.177)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2598",
    "data-name": "Grupo 2598",
    transform: "translate(-109.115 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2589",
    "data-name": "Grupo 2589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2601",
    "data-name": "Grupo 2601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4078",
    "data-name": "Trazado 4078",
    d: "M289.1,26.972h0c124.706,0,225.8,101.095,225.8,225.8s-101.095,225.8-225.8,225.8S63.3,377.478,63.3,252.772,164.4,26.972,289.1,26.972",
    transform: "translate(45.811 19.519)",
    fill: "#fcd0c6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2591",
    "data-name": "Grupo 2591",
    transform: "translate(109.115 46.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2590",
    "data-name": "Grupo 2590",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4079",
    "data-name": "Trazado 4079",
    d: "M297.635,291.948a1.31,1.31,0,0,1-1.26-.96l-2.71-9.77a233.247,233.247,0,0,1-3.353-110.061l7.022-33.289a1.313,1.313,0,0,1,1.282-1.034h.014A1.308,1.308,0,0,1,299.9,137.9l6.722,35.483a233.63,233.63,0,0,1-4.463,106.006l-3.256,11.6a1.31,1.31,0,0,1-1.262.957Z",
    transform: "translate(97.342 52.531)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4080",
    "data-name": "Trazado 4080",
    d: "M299.165,138.688l6.722,35.485a232.763,232.763,0,0,1-4.438,105.413l-3.256,11.6-2.711-9.77a232.792,232.792,0,0,1-3.332-109.441l7.024-33.289m0-2.62a2.618,2.618,0,0,0-2.561,2.079l-7.024,33.289a234.58,234.58,0,0,0,3.372,110.684l2.71,9.77a2.618,2.618,0,0,0,5.043.007l3.258-11.6a234.943,234.943,0,0,0,4.482-106.607L301.73,138.2a2.619,2.619,0,0,0-2.548-2.132Z",
    transform: "translate(96.798 51.979)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4081",
    "data-name": "Trazado 4081",
    d: "M303.177,290.855a1.312,1.312,0,0,1-1.215-.82,324.591,324.591,0,0,1-21.373-149.58l.109-1.207a1.309,1.309,0,0,1,2.525-.355l1.422,3.678a325.56,325.56,0,0,1,20.072,144.236l-.243,2.851a1.292,1.292,0,0,1-1.3,1.2",
    transform: "translate(92.923 53.415)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4082",
    "data-name": "Trazado 4082",
    d: "M282.55,139.913l1.422,3.68a324.524,324.524,0,0,1,19.995,143.654l-.243,2.851a324.1,324.1,0,0,1-21.277-148.973l.109-1.207m0-2.62a2.581,2.581,0,0,0-.365.026,2.618,2.618,0,0,0-2.241,2.36l-.109,1.207A325.929,325.929,0,0,0,301.3,291.075a2.619,2.619,0,0,0,2.43,1.643,2.678,2.678,0,0,0,.39-.029,2.618,2.618,0,0,0,2.222-2.37l.243-2.849a326.868,326.868,0,0,0-20.155-144.823L285,138.968a2.624,2.624,0,0,0-2.442-1.675Z",
    transform: "translate(92.377 52.864)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4083",
    "data-name": "Trazado 4083",
    d: "M321.9,264.414a1.312,1.312,0,0,1-.862-.327c-27.98-24.674-49.449-58.755-62.083-98.559l-.3-.934a1.309,1.309,0,0,1,2.132-1.36l2.175,1.984c26.581,24.212,47.149,57.165,59.479,95.3l.708,2.191a1.3,1.3,0,0,1-1.253,1.706",
    transform: "translate(78.027 71.386)",
    fill: "#eceeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4084",
    "data-name": "Trazado 4084",
    d: "M260.463,164.752l2.177,1.982c26.386,24.033,46.867,56.855,59.113,94.734l.708,2.191c-27.73-24.452-49.171-58.5-61.707-97.975l-.3-.933m0-2.62a2.619,2.619,0,0,0-2.5,3.411l.3.933c12.707,40.032,34.3,74.316,62.466,99.147a2.619,2.619,0,0,0,4.225-2.772l-.708-2.191c-12.4-38.352-33.094-71.5-59.841-95.865l-2.177-1.982a2.607,2.607,0,0,0-1.765-.689Z",
    transform: "translate(77.474 70.832)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4085",
    "data-name": "Trazado 4085",
    d: "M294.117,282.956a1.26,1.26,0,0,1-.214-.017,1.311,1.311,0,0,1-1.1-1.274l-.281-19.957a134.991,134.991,0,0,1,17.211-69.074c11.643-20.32,27.872-35.077,46.934-42.671a1.294,1.294,0,0,1,.484-.093,1.311,1.311,0,0,1,1.081,2.061,449.349,449.349,0,0,0-54.94,107.724l-7.943,22.43a1.311,1.311,0,0,1-1.234.87",
    transform: "translate(102.55 61.965)",
    fill: "#eceeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4086",
    "data-name": "Trazado 4086",
    d: "M357.707,151.734h0a451.205,451.205,0,0,0-55.1,108.027l-7.943,22.43-.281-19.957c-.71-50.319,25.036-95.253,63.319-110.51m0-2.62a2.589,2.589,0,0,0-.969.186c-19.34,7.707-35.794,22.658-47.585,43.236a136.291,136.291,0,0,0-17.392,69.752l.281,19.957a2.618,2.618,0,0,0,2.194,2.548,2.536,2.536,0,0,0,.427.036,2.621,2.621,0,0,0,2.468-1.746l7.941-22.432a448.088,448.088,0,0,1,54.773-107.4,2.62,2.62,0,0,0-2.148-4.121Z",
    transform: "translate(101.998 61.412)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4087",
    "data-name": "Trazado 4087",
    d: "M283.921,270.029a1.3,1.3,0,0,1-.689-.193,1.311,1.311,0,0,1-.543-1.579l6.965-18.471c11.338-30.066,32.253-53.82,57.377-65.168a1.286,1.286,0,0,1,.538-.117h.019c3.461.052,4.45,2.654,6.621,8.355.345.891.712,1.874,1.136,2.954.017.045.031.09.045.134a30.921,30.921,0,0,1-1.912,18.255c-2.629,6.574-11.655,14.841-12.038,15.189a1.308,1.308,0,0,1-2.06-1.539c2.939-6.033,4.654-18.13,2.9-20.541a1.3,1.3,0,0,1-.231-.548c-9.246,8.536-19.7,20.612-29.275,31.664-4.482,5.171-8.715,10.064-12.635,14.379l-15.258,16.8a1.312,1.312,0,0,1-.964.427",
    transform: "translate(95.397 87.027)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4088",
    "data-name": "Trazado 4088",
    d: "M348.121,186.367c3,.045,3.565,2.827,6.55,10.476a29.8,29.8,0,0,1-1.865,17.426c-2.546,6.378-11.7,14.7-11.7,14.7,2.861-5.876,5.071-18.729,2.785-21.891a92.607,92.607,0,0,1,9.461-9.789c-15.008,8.7-37.422,37.324-53.632,55.169l-15.244,16.811,6.965-18.471c11.511-30.523,32.4-53.468,56.69-64.438m0-2.62a2.6,2.6,0,0,0-1.077.233c-25.44,11.49-46.6,35.508-58.062,65.9l-6.967,18.473a2.618,2.618,0,0,0,4.39,2.68l15.26-16.8c3.928-4.325,8.167-9.22,12.653-14.4,9.075-10.476,18.945-21.877,27.773-30.254.593,3.325-.669,12.765-3.339,18.247a2.615,2.615,0,0,0,4.12,3.072c.391-.357,9.634-8.818,12.372-15.67a32.309,32.309,0,0,0,1.962-19.084,2.474,2.474,0,0,0-.09-.269c-.421-1.077-.793-2.055-1.133-2.944-2.168-5.688-3.477-9.135-7.825-9.2Z",
    transform: "translate(94.853 86.471)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4089",
    "data-name": "Trazado 4089",
    d: "M321.7,263.443a1.307,1.307,0,0,1-1.012-.477l-14.06-17.087q-3.41-4.147-6.7-8.213c-11.655-14.339-22.694-27.923-36.388-39.693-.324,4.581.831,10.585,5.7,22.378a1.31,1.31,0,0,1-2.136,1.427c-.434-.433-10.626-10.651-12.805-17.306-3.191-9.74.558-15.751,1.243-16.733.472-1.034.893-1.977,1.277-2.835,2.525-5.654,3.678-8.234,7.089-8.234a1.318,1.318,0,0,1,.572.131c24.266,11.769,43.5,35.938,52.777,66.308l5.688,18.643a1.309,1.309,0,0,1-1.245,1.691",
    transform: "translate(73.994 81.36)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4090",
    "data-name": "Trazado 4090",
    d: "M264.457,178.532c23.432,11.366,42.688,34.7,52.1,65.511l5.688,18.643-14.055-17.094c-14.936-18.152-27.817-35.227-45.095-49.628-.914,4.959-.507,10.935,5.481,25.433,0,0-10.378-10.354-12.484-16.787-3.249-9.918,1.138-15.666,1.138-15.666,3.492-7.634,4.242-10.42,7.229-10.42m0-2.62c-4.261,0-5.688,3.2-8.286,9.01-.371.831-.777,1.739-1.231,2.732-.946,1.422-4.6,7.831-1.339,17.78,2.241,6.831,12.017,16.72,13.126,17.824A2.619,2.619,0,0,0,271,220.4c-3.98-9.63-5.326-15.234-5.6-18.988,12.622,11.257,23.066,24.1,34.06,37.629q3.307,4.067,6.709,8.218l14.06,17.087a2.619,2.619,0,0,0,4.528-2.429l-5.688-18.643c-9.38-30.716-28.865-55.175-53.458-67.1a2.623,2.623,0,0,0-1.143-.262Z",
    transform: "translate(73.448 80.806)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4091",
    "data-name": "Trazado 4091",
    d: "M317.619,283.822a1.308,1.308,0,0,1-1.263-.969,471.4,471.4,0,0,0-46.722-113.662l-11.485-19.877a1.308,1.308,0,0,1,1.884-1.727l13.913,9.728c17.437,12.19,30.962,30.681,39.119,53.468a140.835,140.835,0,0,1,5.845,71.96,1.311,1.311,0,0,1-1.232,1.079Z",
    transform: "translate(77.571 60.141)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4092",
    "data-name": "Trazado 4092",
    d: "M259.831,149.208l13.913,9.728c35.078,24.528,53.142,75,44.424,124.126a473.151,473.151,0,0,0-46.851-113.976L259.833,149.21m0-2.62a2.621,2.621,0,0,0-2.268,3.932L269.049,170.4A470.234,470.234,0,0,1,315.64,283.744a2.618,2.618,0,0,0,2.529,1.939h.116a2.618,2.618,0,0,0,2.465-2.158,142.141,142.141,0,0,0-5.9-72.63c-8.249-23.045-21.942-41.754-39.6-54.1l-13.913-9.728a2.61,2.61,0,0,0-1.5-.472Z",
    transform: "translate(77.022 59.592)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4093",
    "data-name": "Trazado 4093",
    d: "M307.259,250.155,303,254.587a322.592,322.592,0,0,0-19.51-77.858c-1.453-3.692-6.858-14.306-6.858-14.306l6.14,7.981c15.48,20.124,23.478,48.84,22.528,76.045Z",
    transform: "translate(91.074 71.049)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4094",
    "data-name": "Trazado 4094",
    d: "M309.193,257.032A442.363,442.363,0,0,0,275.582,194.1l-7-10.832,7.377,6.853A109.164,109.164,0,0,1,297.8,220.8Z",
    transform: "translate(85.248 86.135)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4095",
    "data-name": "Trazado 4095",
    d: "M294.844,247.689c7.9-24.052,11.242-28.575,27.451-48.461,3-3.685,13.672-13.215,13.672-13.215S318.3,194.631,308.7,206.307Z",
    transform: "translate(104.254 88.121)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4096",
    "data-name": "Trazado 4096",
    d: "M318.152,201.39c1.127,1.507,1.536,7.584-.726,15.553,4.016-4.742,10.64-14.084,10.187-25.338a101.445,101.445,0,0,0-9.461,9.785",
    transform: "translate(120.596 92.168)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4097",
    "data-name": "Trazado 4097",
    d: "M294.41,309.909a1.321,1.321,0,0,1-1.307-1.188c-6.35-66.951,2.941-134.262,26.869-194.659l.562-1.42a1.31,1.31,0,0,1,1.219-.827,1.454,1.454,0,0,1,.193.014,1.31,1.31,0,0,1,1.114,1.188l.436,5.292c5.312,64.413-3.871,129.22-26.56,187.414l-1.306,3.351a1.31,1.31,0,0,1-1.219.836",
    transform: "translate(101.589 34.426)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4098",
    "data-name": "Trazado 4098",
    d: "M322.3,113.677l.436,5.292c5.292,64.153-3.882,128.879-26.474,186.83l-1.307,3.353c-6.314-66.57,2.992-134,26.782-194.054l.562-1.42m0-2.62a2.618,2.618,0,0,0-2.434,1.655l-.564,1.419c-24,60.59-33.325,128.112-26.955,195.266a2.621,2.621,0,0,0,2.241,2.348,2.834,2.834,0,0,0,.362.024,2.619,2.619,0,0,0,2.439-1.669l1.307-3.351c22.752-58.379,31.974-123.387,26.645-188l-.436-5.29a2.626,2.626,0,0,0-2.611-2.4Z",
    transform: "translate(101.04 33.876)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4099",
    "data-name": "Trazado 4099",
    d: "M282.028,308.14a1.31,1.31,0,0,1-1.308-1.251l-3.839-86.552a1.311,1.311,0,0,1,1.308-1.369h51.695a1.311,1.311,0,0,1,1.308,1.369l-3.84,86.552a1.31,1.31,0,0,1-1.308,1.251Z",
    transform: "translate(91.253 111.969)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4100",
    "data-name": "Trazado 4100",
    d: "M330.435,220.828l-3.84,86.552H282.579l-3.84-86.552Zm0-2.62h-51.7a2.619,2.619,0,0,0-2.62,2.737l3.84,86.552a2.619,2.619,0,0,0,2.617,2.5h44.016a2.619,2.619,0,0,0,2.617-2.5l3.84-86.552a2.619,2.619,0,0,0-2.62-2.737Z",
    transform: "translate(90.702 111.419)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4101",
    "data-name": "Trazado 4101",
    d: "M277.688,215.132h54.018a1.724,1.724,0,0,1,1.724,1.724v8.027a1.724,1.724,0,0,1-1.724,1.724H277.688a1.724,1.724,0,0,1-1.724-1.724v-8.027a1.724,1.724,0,0,1,1.724-1.724",
    transform: "translate(90.591 109.193)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4102",
    "data-name": "Trazado 4102",
    d: "M332.669,225.848H277.824v-8.856h54.845Zm0-11.476H277.824a2.621,2.621,0,0,0-2.62,2.62v8.856a2.621,2.621,0,0,0,2.62,2.62h54.845a2.618,2.618,0,0,0,2.62-2.617v-8.86a2.621,2.621,0,0,0-2.62-2.62",
    transform: "translate(90.041 108.643)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4103",
    "data-name": "Trazado 4103",
    d: "M92.615,109.261h83.567a3.446,3.446,0,0,1,3.447,3.447v56.855a3.446,3.446,0,0,1-3.447,3.447H92.615a3.446,3.446,0,0,1-3.447-3.447V112.708a3.446,3.446,0,0,1,3.447-3.447",
    transform: "translate(-44.587 32.578)",
    fill: "#d53955"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_54",
    "data-name": "L\\xEDnea 54",
    x1: 15.287,
    y2: 13.226,
    transform: "translate(134.353 129.665)",
    fill: "none",
    stroke: "#ba2e3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4104",
    "data-name": "Trazado 4104",
    d: "M27.977,109.261h83.567a3.446,3.446,0,0,1,3.447,3.447v56.855a3.446,3.446,0,0,1-3.447,3.447H27.977a3.446,3.446,0,0,1-3.447-3.447V112.708a3.446,3.446,0,0,1,3.447-3.447",
    transform: "translate(-91.363 32.578)",
    fill: "#d53955"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_55",
    "data-name": "L\\xEDnea 55",
    x1: 15.287,
    y2: 13.226,
    transform: "translate(22.939 129.665)",
    fill: "none",
    stroke: "#ba2e3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4105",
    "data-name": "Trazado 4105",
    d: "M92.615,156.476h83.567a3.446,3.446,0,0,1,3.447,3.447v56.855a3.446,3.446,0,0,1-3.447,3.447H92.615a3.446,3.446,0,0,1-3.447-3.447V159.923a3.446,3.446,0,0,1,3.447-3.447",
    transform: "translate(-44.587 66.746)",
    fill: "#d53955"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_56",
    "data-name": "L\\xEDnea 56",
    x1: 15.287,
    y2: 13.226,
    transform: "translate(134.353 211.048)",
    fill: "none",
    stroke: "#ba2e3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4106",
    "data-name": "Trazado 4106",
    d: "M27.777,156.476h83.567a3.446,3.446,0,0,1,3.447,3.447v56.855a3.446,3.446,0,0,1-3.447,3.447H27.777a3.446,3.446,0,0,1-3.447-3.447V159.923a3.446,3.446,0,0,1,3.447-3.447",
    transform: "translate(-91.508 66.746)",
    fill: "#d53955"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_57",
    "data-name": "L\\xEDnea 57",
    x1: 15.287,
    y2: 13.226,
    transform: "translate(22.594 211.048)",
    fill: "none",
    stroke: "#ba2e3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4107",
    "data-name": "Trazado 4107",
    d: "M258.068,100a6.549,6.549,0,0,1,6.55,6.55V391.093H2.62V100Zm0-2.62H2.62A2.62,2.62,0,0,0,0,100v291.1a2.619,2.619,0,0,0,2.62,2.62h262a2.62,2.62,0,0,0,2.62-2.62V106.545a9.181,9.181,0,0,0-9.168-9.168Z",
    transform: "translate(-109.115 23.978)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4108",
    "data-name": "Trazado 4108",
    d: "M192.3,175.944H91.788V104.208H192.3Zm0-74.356H91.788a2.62,2.62,0,0,0-2.62,2.62v71.736a2.62,2.62,0,0,0,2.62,2.62H192.3a2.62,2.62,0,0,0,2.62-2.62V104.208A2.62,2.62,0,0,0,192.3,101.588Z",
    transform: "translate(-44.587 27.025)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4109",
    "data-name": "Trazado 4109",
    d: "M189.678,151.728a2.623,2.623,0,0,1,2.62,2.62v66.5a2.623,2.623,0,0,1-2.62,2.62H94.408a2.623,2.623,0,0,1-2.62-2.62v-66.5a2.623,2.623,0,0,1,2.62-2.62Zm0-2.62H94.408a5.24,5.24,0,0,0-5.24,5.24v66.5a5.24,5.24,0,0,0,5.24,5.24h95.271a5.24,5.24,0,0,0,5.24-5.24v-66.5a5.24,5.24,0,0,0-5.24-5.24",
    transform: "translate(-44.587 61.414)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4110",
    "data-name": "Trazado 4110",
    d: "M124.842,104.208a2.623,2.623,0,0,1,2.62,2.62v66.5a2.623,2.623,0,0,1-2.62,2.62H29.573a2.623,2.623,0,0,1-2.62-2.62v-66.5a2.623,2.623,0,0,1,2.62-2.62Zm0-2.62H29.573a5.239,5.239,0,0,0-5.24,5.237v66.5a5.24,5.24,0,0,0,5.24,5.24h95.269a5.24,5.24,0,0,0,5.24-5.24v-66.5a5.239,5.239,0,0,0-5.236-5.24Z",
    transform: "translate(-91.506 27.025)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4111",
    "data-name": "Trazado 4111",
    d: "M124.842,151.728a2.623,2.623,0,0,1,2.62,2.62v66.5a2.622,2.622,0,0,1-2.62,2.62H29.573a2.622,2.622,0,0,1-2.62-2.62v-66.5a2.623,2.623,0,0,1,2.62-2.62Zm0-2.62H29.573a5.24,5.24,0,0,0-5.24,5.24v66.5a5.24,5.24,0,0,0,5.24,5.24h95.269a5.24,5.24,0,0,0,5.24-5.24v-66.5a5.24,5.24,0,0,0-5.24-5.24",
    transform: "translate(-91.506 61.414)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4112",
    "data-name": "Trazado 4112",
    d: "M92.615,205.445h83.567a3.446,3.446,0,0,1,3.447,3.447v56.855a3.446,3.446,0,0,1-3.447,3.447H92.615a3.446,3.446,0,0,1-3.447-3.447V208.892a3.446,3.446,0,0,1,3.447-3.447",
    transform: "translate(-44.587 102.183)",
    fill: "#d53955"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_58",
    "data-name": "L\\xEDnea 58",
    x1: 15.287,
    y2: 13.226,
    transform: "translate(134.353 295.454)",
    fill: "none",
    stroke: "#ba2e3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4113",
    "data-name": "Trazado 4113",
    d: "M27.777,205.445h83.567a3.446,3.446,0,0,1,3.447,3.447v56.855a3.446,3.446,0,0,1-3.447,3.447H27.777a3.446,3.446,0,0,1-3.447-3.447V208.892a3.446,3.446,0,0,1,3.447-3.447",
    transform: "translate(-91.508 102.183)",
    fill: "#d53955"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_59",
    "data-name": "L\\xEDnea 59",
    x1: 15.287,
    y2: 13.226,
    transform: "translate(22.594 295.454)",
    fill: "none",
    stroke: "#ba2e3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4114",
    "data-name": "Trazado 4114",
    d: "M189.678,200.7a2.623,2.623,0,0,1,2.62,2.62v66.5a2.623,2.623,0,0,1-2.62,2.62H94.408a2.623,2.623,0,0,1-2.62-2.62v-66.5a2.623,2.623,0,0,1,2.62-2.62Zm0-2.62H94.408a5.24,5.24,0,0,0-5.24,5.24v66.5a5.24,5.24,0,0,0,5.24,5.24h95.271a5.24,5.24,0,0,0,5.24-5.24v-66.5a5.24,5.24,0,0,0-5.24-5.24",
    transform: "translate(-44.587 96.851)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4115",
    "data-name": "Trazado 4115",
    d: "M124.842,200.7a2.623,2.623,0,0,1,2.62,2.62v66.5a2.622,2.622,0,0,1-2.62,2.62H29.573a2.622,2.622,0,0,1-2.62-2.62v-66.5a2.623,2.623,0,0,1,2.62-2.62Zm0-2.62H29.573a5.24,5.24,0,0,0-5.24,5.24v66.5a5.24,5.24,0,0,0,5.24,5.24h95.269a5.24,5.24,0,0,0,5.24-5.24v-66.5a5.24,5.24,0,0,0-5.24-5.24",
    transform: "translate(-91.506 96.851)",
    fill: "#ba2e3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2334",
    "data-name": "Rect\\xE1ngulo 2334",
    width: 38.488,
    height: 33.603,
    transform: "translate(50.633 250.621)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2335",
    "data-name": "Rect\\xE1ngulo 2335",
    width: 38.488,
    height: 33.603,
    transform: "translate(50.633 250.621)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2336",
    "data-name": "Rect\\xE1ngulo 2336",
    width: 14.501,
    height: 5.428,
    transform: "translate(61.264 264.867)",
    fill: "#1c559a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4116",
    "data-name": "Trazado 4116",
    d: "M113.375,179.114a5.338,5.338,0,1,1-5.338,5.338,5.339,5.339,0,0,1,5.338-5.338",
    transform: "translate(-30.932 83.128)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2337",
    "data-name": "Rect\\xE1ngulo 2337",
    width: 38.488,
    height: 27.568,
    transform: "translate(50.633 221.912)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2338",
    "data-name": "Rect\\xE1ngulo 2338",
    width: 38.488,
    height: 27.568,
    transform: "translate(50.633 221.912)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2339",
    "data-name": "Rect\\xE1ngulo 2339",
    width: 14.501,
    height: 5.428,
    transform: "translate(61.264 230.123)",
    fill: "#1c559a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4117",
    "data-name": "Trazado 4117",
    d: "M113.375,158.957a5.338,5.338,0,1,1-5.338,5.338,5.339,5.339,0,0,1,5.338-5.338",
    transform: "translate(-30.932 68.541)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2340",
    "data-name": "Rect\\xE1ngulo 2340",
    width: 38.488,
    height: 27.725,
    transform: "translate(97.296 256.365)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2341",
    "data-name": "Rect\\xE1ngulo 2341",
    width: 38.488,
    height: 27.725,
    transform: "translate(97.296 256.365)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2342",
    "data-name": "Rect\\xE1ngulo 2342",
    width: 14.501,
    height: 5.428,
    transform: "translate(107.927 264.733)",
    fill: "#1c559a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4118",
    "data-name": "Trazado 4118",
    d: "M140.447,179.036a5.338,5.338,0,1,1-5.338,5.338,5.339,5.339,0,0,1,5.338-5.338",
    transform: "translate(-11.341 83.072)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2343",
    "data-name": "Rect\\xE1ngulo 2343",
    width: 38.488,
    height: 27.725,
    transform: "translate(50.207 174.209)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2344",
    "data-name": "Rect\\xE1ngulo 2344",
    width: 38.488,
    height: 27.725,
    transform: "translate(50.207 174.209)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2345",
    "data-name": "Rect\\xE1ngulo 2345",
    width: 14.501,
    height: 5.428,
    transform: "translate(60.839 182.578)",
    fill: "#1c559a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4119",
    "data-name": "Trazado 4119",
    d: "M113.128,131.373a5.338,5.338,0,1,1-5.338,5.338,5.339,5.339,0,0,1,5.338-5.338",
    transform: "translate(-31.111 48.58)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2346",
    "data-name": "Rect\\xE1ngulo 2346",
    width: 10.397,
    height: 37.699,
    transform: "translate(-7.801 246.64) rotate(-7.066)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2347",
    "data-name": "Rect\\xE1ngulo 2347",
    width: 10.397,
    height: 37.699,
    transform: "translate(-7.801 246.64) rotate(-7.066)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2348",
    "data-name": "Rect\\xE1ngulo 2348",
    width: 10.397,
    height: 37.699,
    transform: "translate(4.248 246.64) rotate(-7.066)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2349",
    "data-name": "Rect\\xE1ngulo 2349",
    width: 10.397,
    height: 37.699,
    transform: "translate(4.248 246.64) rotate(-7.066)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2350",
    "data-name": "Rect\\xE1ngulo 2350",
    width: 10.397,
    height: 37.699,
    transform: "translate(89.81 217.623) rotate(-7.066)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2351",
    "data-name": "Rect\\xE1ngulo 2351",
    width: 10.397,
    height: 37.699,
    transform: "translate(89.81 217.623) rotate(-7.066)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2352",
    "data-name": "Rect\\xE1ngulo 2352",
    width: 38.488,
    height: 27.725,
    transform: "translate(-15.279 342.16)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2353",
    "data-name": "Rect\\xE1ngulo 2353",
    width: 38.488,
    height: 27.725,
    transform: "translate(-15.279 342.16)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2354",
    "data-name": "Rect\\xE1ngulo 2354",
    width: 14.501,
    height: 5.428,
    transform: "translate(-4.647 350.528)",
    fill: "#1c559a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4120",
    "data-name": "Trazado 4120",
    d: "M75.136,228.811a5.338,5.338,0,1,1-5.338,5.338,5.339,5.339,0,0,1,5.338-5.338",
    transform: "translate(-58.605 119.092)",
    fill: "#5578a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2355",
    "data-name": "Rect\\xE1ngulo 2355",
    width: 10.397,
    height: 37.699,
    transform: "translate(101.571 217.479) rotate(-7.066)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2356",
    "data-name": "Rect\\xE1ngulo 2356",
    width: 10.397,
    height: 37.699,
    transform: "translate(101.571 217.479) rotate(-7.066)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2357",
    "data-name": "Rect\\xE1ngulo 2357",
    width: 10.397,
    height: 37.699,
    transform: "translate(88.695 164.508) rotate(-7.066)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2358",
    "data-name": "Rect\\xE1ngulo 2358",
    width: 10.397,
    height: 37.699,
    transform: "translate(88.695 164.508) rotate(-7.066)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2359",
    "data-name": "Rect\\xE1ngulo 2359",
    width: 10.397,
    height: 37.699,
    transform: "translate(100.454 164.508) rotate(-7.066)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2360",
    "data-name": "Rect\\xE1ngulo 2360",
    width: 10.397,
    height: 37.699,
    transform: "translate(100.454 164.508) rotate(-7.066)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2361",
    "data-name": "Rect\\xE1ngulo 2361",
    width: 10.397,
    height: 37.699,
    transform: "translate(112.199 164.508) rotate(-7.066)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2362",
    "data-name": "Rect\\xE1ngulo 2362",
    width: 10.397,
    height: 37.699,
    transform: "translate(112.199 164.508) rotate(-7.066)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2363",
    "data-name": "Rect\\xE1ngulo 2363",
    width: 10.397,
    height: 37.699,
    transform: "translate(123.958 164.508) rotate(-7.066)",
    fill: "#fcd0c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2364",
    "data-name": "Rect\\xE1ngulo 2364",
    width: 10.397,
    height: 37.699,
    transform: "translate(123.958 164.508) rotate(-7.066)",
    fill: "none",
    stroke: "#b787a0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_41",
    "data-name": "Elipse 41",
    cx: 20.956,
    cy: 20.956,
    r: 20.956,
    transform: "translate(293.441 158.015) rotate(-80.783)",
    fill: "none",
    stroke: "#ba2e3c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4121",
    "data-name": "Trazado 4121",
    d: "M258.313,125.8l-10.818-9.908V98.5",
    transform: "translate(69.989 24.793)",
    fill: "none",
    stroke: "#ba2e3c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2365",
    "data-name": "Rect\\xE1ngulo 2365",
    width: 451.601,
    height: 101.412,
    transform: "translate(-4.013 397.555)",
    fill: "#e9546d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2593",
    "data-name": "Grupo 2593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2600",
    "data-name": "Grupo 2600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4123",
    "data-name": "Trazado 4123",
    d: "M157.173,142.308c.041.117.095.229.136.345l.305.029c-.279-.495-.552-.995-.808-1.5.117.39.236.762.367,1.127",
    transform: "translate(113.475 102.168)",
    fill: "#5e180b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4124",
    "data-name": "Trazado 4124",
    d: "M250.621,136.9a2.086,2.086,0,0,0-.77-.838,2.08,2.08,0,0,0-.04-3.29,2.076,2.076,0,0,0,.974-1.065,2.1,2.1,0,0,0-1.158-2.729h0l-.074-.029a2.089,2.089,0,0,0-.348-3.887l-2.73-.784,2.387-.786a2.1,2.1,0,1,0-1.308-3.983h0l-.448.146a2.042,2.042,0,0,0-.248-.665l1.3-.826a2.094,2.094,0,0,0-1.02-3.861,2.1,2.1,0,0,0-2.194-3.258l0,0-.507.122.345-.814a2.093,2.093,0,0,0-1.088-2.754l-.007,0a2.089,2.089,0,0,0-1.879.115,2.093,2.093,0,0,0-2.2-2.089,2.06,2.06,0,0,0,.059-1.443,2.1,2.1,0,0,0-1.863-1.436,2.091,2.091,0,0,0-.979-4.061l-2.794.517,1.786-1.77a2.1,2.1,0,1,0-2.949-2.979l-2.349,2.325L232.8,92.99a2.095,2.095,0,0,0-2.635-3,2.088,2.088,0,0,0-3.415-1.925l-.4.336-.05-.884a2.1,2.1,0,0,0-2.208-1.977h0a2.093,2.093,0,0,0-1.629.941,2.084,2.084,0,0,0-2.9-.889,2.086,2.086,0,0,0-3.556-1.332l-2.275,2.3a5.987,5.987,0,0,1-3.363-.5V86.04c-.1-.031-.205-.057-.305-.088l.279-3.125a2.09,2.09,0,0,0-3.677-1.543,2.085,2.085,0,0,0-3.906-.234l-.21.477-.431-.774a2.1,2.1,0,0,0-2.851-.81h0a2.089,2.089,0,0,0-1.051,1.551,2.087,2.087,0,0,0-2.994.469,2.072,2.072,0,0,0-3.139-.55,2.09,2.09,0,0,0-3.894.031l0,0-1,2.6h-.029l-.565-2.4a2.1,2.1,0,0,0-4.083.96L183,84.7l-.291.057-1.486-2.861A2.1,2.1,0,0,0,178.4,81h0a2.093,2.093,0,0,0-1.108,1.575,2.088,2.088,0,0,0-3.425,1.9v0l.079.517-.781-.421a2.092,2.092,0,0,0-2.887,2.732,2.084,2.084,0,0,0-2.272,2,2.057,2.057,0,0,0-2.42.371,2.09,2.09,0,0,0-1.777,2.053v.707c-.334.221-.669.443-1,.672l-.421-.624a2.1,2.1,0,1,0-3.478,2.339l.567.843c-.145.122-.283.25-.426.374l-1.6-1.431a2.093,2.093,0,0,0-3.439,2.029,2.087,2.087,0,0,0-2.523,2.994l0,0,.255.455-.877-.117a2.091,2.091,0,0,0-1.734,3.577,2.083,2.083,0,0,0-1.415,2.68,2.082,2.082,0,0,0-2.191,2.816,2.092,2.092,0,0,0-3.32,2.532l1.465,2.2-.1.081L141.454,113a2.094,2.094,0,0,0-2.729,1.15l0,0a2.1,2.1,0,0,0,1.153,2.732l.969.395c-.1.172-.193.345-.286.517l-2.012-.281a2.093,2.093,0,0,0-1.72,3.6,2.09,2.09,0,0,0-.427,3.9h0l.465.233-.795.393a2.092,2.092,0,0,0,.558,3.937,2.085,2.085,0,0,0,.322,3.015,2.087,2.087,0,0,0,.176,3.794l2.413.977a2.089,2.089,0,0,0-.122,3.921l1.344.546c-.057.148-.126.283-.172.434l-2.494-.345a2.093,2.093,0,0,0-1.72,3.6,2.09,2.09,0,0,0-.426,3.9l.467.233-.793.393a2.092,2.092,0,0,0,.558,3.937,2.086,2.086,0,0,0,.322,3.015,2.069,2.069,0,0,0-.977,1.062,2.093,2.093,0,0,0,1.15,2.729l0,0,3.528,1.434-.969.44a2.1,2.1,0,0,0,1.729,3.82l1.593-.72c.052.122.1.245.152.369l-2.2,1.753a2.094,2.094,0,0,0,1.427,3.73,2.086,2.086,0,0,0,2.532,2.987l.49-.172-.262.846a2.088,2.088,0,0,0,3.232,2.306,2.087,2.087,0,0,0,2.406,1.844,2.087,2.087,0,0,0,2.87,2.487l1.312-.595a17.972,17.972,0,0,0,12.927,3.909c.9.327,1.243-.243,1.243-.243a11.535,11.535,0,0,0,1.9-.658c6.583-2.975,9.52-11.559,8.193-21.394a57.181,57.181,0,0,0,15.191,2.039,55.54,55.54,0,0,0,25.286-5.94c-4.309,7.22-3.914,15.42.976,18.479,4.983,3.12,12.74-.284,17.321-7.6a20.044,20.044,0,0,0,3.218-10.514,2.091,2.091,0,0,0,2.413-3.146l-.614-.917a2.093,2.093,0,0,0,2.81-2.965l0,0-1.41-2.1,2.539,1.024a2.1,2.1,0,0,0,2.251-3.442,2.08,2.08,0,0,0,1.3-3.523c.028-.047.06-.086.084-.134a2.1,2.1,0,0,0-.941-2.811l-1.422-.71,1.912-.953a2.1,2.1,0,0,0,.927-2.81m-111.3,15.989v.122l-.345.047Zm83.007-61.576c-.172-.109-.359-.215-.538-.321l.434-1.551Zm22.208,24.174-.014-.022.078-.019Zm1.536,16.573,1.1.445-1.113.15C246.062,132.462,246.069,132.264,246.07,132.064Zm-6.3-21.268.486-.538-.362.843C239.855,111,239.815,110.9,239.774,110.8Zm-4.288-7.584,1.055-.195-.969.319c-.028-.045-.055-.086-.086-.128Zm10.29,33.722.126-.017-.131.065ZM228.422,92.156l-1.427,2.365c-.146-.114-.29-.233-.44-.345a2.021,2.021,0,0,0,.079-.517Zm-22.752-7.3.374-.848-.079.907c-.1-.024-.2-.041-.3-.062Zm-27.163.915-.2.057-.095-.614ZM156,98.954l-.06.064-.133-.238Zm-16.471,47.6-.5-.252.517.072a1.192,1.192,0,0,1-.019.176Zm4.781,23.661.309-.246.064.112Zm87.39-20.3a42.35,42.35,0,0,0,2.863-3.275V150.1a8.712,8.712,0,0,0-2.867-.191Z",
    transform: "translate(97.303 57.66)",
    fill: "#5e180b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4125",
    "data-name": "Trazado 4125",
    d: "M161.9,102.04v43.24a14.185,14.185,0,0,1-.6-2.413,8.79,8.79,0,0,0-7.7-7.412c-.267-.022-.536-.041-.808-.041a8.968,8.968,0,0,0-6.331,2.6c-.222.236-.453.5-.689.776a8.89,8.89,0,0,0-1.96,5.576v1.56a13.169,13.169,0,0,0,4.245,9.825c3.942,3.54,8.234,3.327,11.031,1.225,1.1-.827,2.749,1.519,2.811,2.682v52.587a22.987,22.987,0,0,0,45.974,0v-16.1a17.413,17.413,0,0,1-4.885.689,38.257,38.257,0,0,1-29.928-14.434,40.013,40.013,0,0,1-6.483-11.749c-.131-.367-.248-.746-.367-1.127a38.474,38.474,0,0,0,4.244,6.6l.248.314a38,38,0,0,0,29.719,14.329h.131a17.89,17.89,0,0,0,7.322-1.551c.117-.04.222-.091.345-.145a17.964,17.964,0,0,0,6.235-4.768A56.407,56.407,0,0,0,227.7,147.95V102.04Z",
    transform: "translate(104.072 73.843)",
    fill: "#c2683b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4126",
    "data-name": "Trazado 4126",
    d: "M198.47,160.869v6.941a17.411,17.411,0,0,1-4.885.689,38.257,38.257,0,0,1-29.928-14.434,40.035,40.035,0,0,1-6.483-11.749c-.131-.367-.248-.746-.367-1.127a38.475,38.475,0,0,0,4.244,6.6l.248.314a38,38,0,0,0,29.719,14.329h.131a17.89,17.89,0,0,0,7.32-1.565",
    transform: "translate(113.476 102.175)",
    fill: "#995230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4127",
    "data-name": "Trazado 4127",
    d: "M154.265,133.192c-.533-4.092-3.692-7.748-6.665-7.034",
    transform: "translate(106.813 91.231)",
    fill: "none",
    stroke: "#543822",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4128",
    "data-name": "Trazado 4128",
    d: "M157.382,139.425h0a4.6,4.6,0,1,1,0-6.5,4.6,4.6,0,0,1,0,6.5",
    transform: "translate(108.213 95.218)",
    fill: "#fbf6df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4129",
    "data-name": "Trazado 4129",
    d: "M240.17,126.072l-.016-6.538a9.488,9.488,0,0,0-9.551-9.4,31.889,31.889,0,0,0-30.6-22.49H183.241a40.025,40.025,0,0,0-37.562,25.822,49.92,49.92,0,0,0,.517,36.369c.145-.215.272-.441.434-.643.238-.278.467-.54.689-.776a8.968,8.968,0,0,1,6.331-2.6c.272,0,.541.019.808.041a8.79,8.79,0,0,1,7.7,7.412,42.94,42.94,0,0,0,.967,4.187.861.861,0,0,0,1.6-.1,83.568,83.568,0,0,0,4.32-26.513v-2.4a16.794,16.794,0,0,0,15.046-9.235l.738-1.477h.134l.369.274a54.913,54.913,0,0,0,43.312,9.628V155.7a43.691,43.691,0,0,0,11.521-29.623",
    transform: "translate(103.124 63.424)",
    fill: "#5e180b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4130",
    "data-name": "Trazado 4130",
    d: "M188.5,123.571a3.785,3.785,0,1,1-3.275,3.751,3.537,3.537,0,0,1,3.275-3.751",
    transform: "translate(134.041 89.424)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4131",
    "data-name": "Trazado 4131",
    d: "M172.407,123.271a3.785,3.785,0,1,1-3.275,3.751,3.537,3.537,0,0,1,3.275-3.751",
    transform: "translate(122.395 89.207)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4132",
    "data-name": "Trazado 4132",
    d: "M177.626,140.463H185.6a1,1,0,0,0,.951-1.286l-3.792-12.4",
    transform: "translate(128.542 91.744)",
    fill: "#b77447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4133",
    "data-name": "Trazado 4133",
    d: "M177.626,140.463H185.6a1,1,0,0,0,.951-1.286l-3.792-12.4",
    transform: "translate(128.542 91.744)",
    fill: "none",
    stroke: "#8b4626",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4134",
    "data-name": "Trazado 4134",
    d: "M180.5,116.893c-.205-1.155-4.009-1.451-8.5-.662s-7.967,2.367-7.756,3.521",
    transform: "translate(118.852 83.793)",
    fill: "#4a160d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4135",
    "data-name": "Trazado 4135",
    d: "M183.6,116.714c.205-1.155,4.009-1.451,8.5-.66s7.967,2.365,7.757,3.521",
    transform: "translate(132.865 83.664)",
    fill: "#4a160d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4136",
    "data-name": "Trazado 4136",
    d: "M170.4,136.9a15.329,15.329,0,0,0,13.272,4.88",
    transform: "translate(123.312 99.071)",
    fill: "none",
    stroke: "#d91c28",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_42",
    "data-name": "Elipse 42",
    cx: 13.705,
    cy: 13.705,
    r: 13.705,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 277.457, 227.203)",
    fill: "none",
    stroke: "#f1e46c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_43",
    "data-name": "Elipse 43",
    cx: 13.705,
    cy: 13.705,
    r: 13.705,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 311.834, 227.203)",
    fill: "none",
    stroke: "#f1e46c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_60",
    "data-name": "L\\xEDnea 60",
    x1: 7.395,
    transform: "translate(306.67 213.49)",
    fill: "none",
    stroke: "#f1e46c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_61",
    "data-name": "L\\xEDnea 61",
    x2: 17.132,
    y2: 6.143,
    transform: "translate(262.344 207.345)",
    fill: "none",
    stroke: "#f1e46c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4137",
    "data-name": "Trazado 4137",
    d: "M155.042,160.342v-39.06a37.922,37.922,0,0,1,38.071-37.766",
    transform: "translate(112.199 60.438)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4138",
    "data-name": "Trazado 4138",
    d: "M151.829,123.118c4.868-2.13,11.219,1.639,14.187,8.418s1.429,14-3.439,16.137-11.219-1.639-14.188-8.42-1.429-14,3.439-16.135",
    transform: "translate(106.292 88.666)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4139",
    "data-name": "Trazado 4139",
    d: "M150.914,124.274c4.2-1.837,9.678,1.413,12.238,7.262s1.232,12.079-2.966,13.917-9.678-1.413-12.238-7.262-1.232-12.079,2.966-13.917",
    transform: "translate(106.122 89.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4140",
    "data-name": "Trazado 4140",
    d: "M173.643,152.666h3.311a3.98,3.98,0,0,1,0,7.96h-3.311a3.98,3.98,0,1,1,0-7.96",
    transform: "translate(122.78 110.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4141",
    "data-name": "Trazado 4141",
    d: "M187.418,169.742a35.6,35.6,0,0,1-35.606-35.606v0",
    transform: "translate(109.861 97.068)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4142",
    "data-name": "Trazado 4142",
    d: "M157.738,121.637A37.92,37.92,0,0,1,195.809,83.87a38.546,38.546,0,0,1,6.722.6,36.546,36.546,0,0,0-13.057-2.4h-3.34a36.256,36.256,0,0,0-36.4,36.109V160.69h8Z",
    transform: "translate(108.358 59.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4143",
    "data-name": "Trazado 4143",
    d: "M157.738,121.637A37.92,37.92,0,0,1,195.809,83.87a38.546,38.546,0,0,1,6.722.6,36.546,36.546,0,0,0-13.057-2.4h-3.34a36.256,36.256,0,0,0-36.4,36.109V160.69h8Z",
    transform: "translate(108.358 59.389)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2595",
    "data-name": "Grupo 2595",
    transform: "translate(136.569 272.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2594",
    "data-name": "Grupo 2594",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4144",
    "data-name": "Trazado 4144",
    d: "M408.212,283.83,353.523,152.487H162.586L58.688,354.811H338.846l16.184-6Z",
    transform: "translate(-94.099 -162.295)",
    fill: "#005cb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4145",
    "data-name": "Trazado 4145",
    d: "M195.146,306.3h71.9l-51.71-109.51a6.522,6.522,0,0,0-11.976.422,56.444,56.444,0,0,0-3.773,17.728Z",
    transform: "translate(4.652 -132.94)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4146",
    "data-name": "Trazado 4146",
    d: "M173.79,276.205l-69.272-9.989,46-70.477a11.189,11.189,0,0,1,16.854-2.2,35.97,35.97,0,0,1,11.721,30.35Z",
    transform: "translate(-60.933 -134.666)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4147",
    "data-name": "Trazado 4147",
    d: "M129.636,263.51l-12.895-1.86,28.478-60.475Z",
    transform: "translate(-52.088 -127.061)",
    fill: "#5e97be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4148",
    "data-name": "Trazado 4148",
    d: "M210.364,292.505l-5.049-.155-1.663-80.24Z",
    transform: "translate(10.807 -119.147)",
    fill: "#6290a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4149",
    "data-name": "Trazado 4149",
    d: "M194.841,269.527h-37.3l3.87-25.664,6.936.128c14.846.326,35.458,11.485,36.13,25.538h-9.639Z",
    transform: "translate(-22.56 -96.169)",
    fill: "#ffabad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4150",
    "data-name": "Trazado 4150",
    d: "M101.828,276.305h96.036l5.4-27.848-96.8-13.962Z",
    transform: "translate(-62.88 -102.947)",
    fill: "#005cb1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_62",
    "data-name": "L\\xEDnea 62",
    x2: 96.805,
    y2: 13.958,
    transform: "translate(43.58 131.552)",
    fill: "none",
    stroke: "#1b124f",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2597",
    "data-name": "Grupo 2597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2599",
    "data-name": "Grupo 2599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4152",
    "data-name": "Trazado 4152",
    d: "M171.336,206.66l9.272-.915-9.022-38.7a.43.43,0,0,0-.434-.333L164,172.185Z",
    transform: "translate(118.679 120.645)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4153",
    "data-name": "Trazado 4153",
    d: "M168.238,208.1h4.4c2.941,0,5.2,1.682,5.428-1.279l7.465-24.092-3.858-17.507-5.245,2.629Z",
    transform: "translate(121.748 119.567)",
    fill: "#005cb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4154",
    "data-name": "Trazado 4154",
    d: "M175.969,181.215l-20.732-26.989-7.782,7.27L167.231,191.6l9.7-5.861a36.2,36.2,0,0,0-.964-4.526",
    transform: "translate(106.708 111.608)",
    fill: "#1f446a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4155",
    "data-name": "Trazado 4155",
    d: "M183.063,191.914,193.3,166.493l-4.716-12.264-15.594,21.58,6.665,16.935a2.015,2.015,0,0,0,3.408-.831",
    transform: "translate(125.187 111.611)",
    fill: "#1f446a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4156",
    "data-name": "Trazado 4156",
    d: "M185.03,189.354l10.451-27.68-6.895-7.445-15.594,21.58Z",
    transform: "translate(125.189 111.611)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4157",
    "data-name": "Trazado 4157",
    d: "M168.421,175.824c.664-.117,1.353.657,1.541,1.727s-.2,2.034-.86,2.149-1.351-.657-1.541-1.727.2-2.032.86-2.149",
    transform: "translate(121.224 127.23)",
    fill: "#003765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4158",
    "data-name": "Trazado 4158",
    d: "M172.772,172.027l-7.81,4.7-.965-5,7.019-4.956a.392.392,0,0,1,.546.091.431.431,0,0,1,.062.141Z",
    transform: "translate(118.679 120.636)",
    fill: "#88c0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4159",
    "data-name": "Trazado 4159",
    d: "M183.132,175.735l-27.894-21.506-7.782,7.272,19.777,30.106Z",
    transform: "translate(106.708 111.611)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4160",
    "data-name": "Trazado 4160",
    d: "M352.413,298.84H169.32a6.9,6.9,0,0,1-6.938-6.852v-5.026l53.951-.24,20.7-80.247a4.175,4.175,0,0,1,4.056-3.118h131.3a4.151,4.151,0,0,1,4.082,5.057l-19.97,87.2a4.174,4.174,0,0,1-4.089,3.228",
    transform: "translate(117.511 147.163)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    cx: 7.981,
    cy: 7.981,
    r: 7.981,
    transform: "translate(408.595 389.056)",
    fill: "none",
    stroke: "#b3c7d4",
    strokeWidth: 1.313
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4161",
    "data-name": "Trazado 4161",
    d: "M232.481,110.9V58.535A31.436,31.436,0,0,1,248.6,31.084l48.563-27.1a31.439,31.439,0,0,1,30.636,0l48.563,27.1a31.436,31.436,0,0,1,16.116,27.451V110.9a31.436,31.436,0,0,1-16.116,27.451l-48.563,27.1a31.439,31.439,0,0,1-30.636,0l-48.563-27.1A31.436,31.436,0,0,1,232.481,110.9",
    transform: "translate(168.239 0)",
    fill: "#f73f61"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2367",
    "data-name": "Rect\\xE1ngulo 2367",
    width: 83.474,
    height: 7.622,
    transform: "translate(438.98 108.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2368",
    "data-name": "Rect\\xE1ngulo 2368",
    width: 51.462,
    height: 5.45,
    transform: "translate(454.986 130.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4162",
    "data-name": "Trazado 4162",
    d: "M320.389,83.825H268.507A11.076,11.076,0,0,1,258.7,67.537L284.64,19.078a11.135,11.135,0,0,1,19.619,0L330.2,67.537a11.076,11.076,0,0,1-9.811,16.289Z",
    transform: "translate(186.269 9.56)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4163",
    "data-name": "Trazado 4163",
    d: "M321.135,86.336H269.256A12.842,12.842,0,0,1,257.89,67.452l25.941-48.463a12.921,12.921,0,0,1,22.752,0l25.938,48.463a12.839,12.839,0,0,1-11.387,18.885M295.2,15.724a9.218,9.218,0,0,0-8.253,4.93L261,69.113A9.31,9.31,0,0,0,269.256,82.8h51.879a9.31,9.31,0,0,0,8.253-13.689L303.447,20.654a9.222,9.222,0,0,0-8.249-4.93",
    transform: "translate(185.52 8.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4164",
    "data-name": "Trazado 4164",
    d: "M275.824,56.834H285V65.39h-9.173Zm.345-34.608h8.556V33.475l-2.258,18.3H278.43l-2.258-18.3Z",
    transform: "translate(199.605 16.084)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAuthorized);
export default __webpack_public_path__ + "static/media/NoAuthorized.ced7f5b07a528bccc0888b94716bd0a8.svg";
export { ForwardRef as ReactComponent };